import { Component, OnInit } from "@angular/core";
import { User } from "../shared/model/user.model";
import { UserSettingsService } from "../shared/services/user-setting.service";
import { environment } from "src/environments/environment";
import { PermissionService } from "../shared/services/permissions.service";

@Component({
  selector: "app-pages",
  templateUrl: "./pages.component.html",
  styleUrls: ["./pages.component.scss"],
  standalone: false,
})
export class PagesComponent implements OnInit {
  isCollapsed = false;
  canAccessChatEzia = false;
  user: User;
  isProd = false;

  navList = [
    {
      title: " Clientes ",
      url: "/pages/clientes",
      icon: "table",
    },
  ];

  views = [
    {
      title: "Dashboard",
      url: "/pages/dashboard",
      icon: "table",
      link: "clientes",
      name: "Dashboard",
      havePermission: true,
    },
    {
      title: "Leads",
      url: "/pages/contacts",
      icon: "table",
      link: "Leads",
      name: "Leads",
      havePermission: this.isContactManager,
    },
  ];
  constructor(public UserService: UserSettingsService, public permissionService: PermissionService) {}

  ngOnInit() {
    this.isProd = environment.production;
  }

  get isContactManager() {
    return this.permissionService.hasPermission("view_contacts_menu");
  }

}
